import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { MessageService } from 'src/app/common/services/message';
import { UtilsService } from 'src/app/common/services/utils';
import { UserService } from '../user.service';

@Component({
  selector: 'app-password-update',
  templateUrl: './password-update.component.html',
  styleUrls: ['./password-update.component.scss']
})
export class PasswordUpdateComponent {
  form: FormGroup;
  loading = false;
  constructor(
    private modal: NzModalRef,
    private fb: FormBuilder,
    private userService: UserService,
    private message: MessageService
  ) {
    this.form = this.fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, this.confirmValidator]]
    });
  }

  /**
   * 确认密码验证器
   */
  confirmValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { error: true, required: true };
    } else if (control.value !== this.form.controls.newPassword.value) {
      return { confirm: true, error: true };
    }
    return {};
  };

  /**
   * 密码强度验证
   */
  validatePasswordStrength(): boolean {
    const password = this.form.controls.newPassword.value;
    if (!password) return true;
    
    // 至少包含数字、字母，长度至少6位
    const strongRegex = /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/;
    return strongRegex.test(password);
  }

  /**
   * 取消操作
   */
  cancelClick() {
    this.modal.destroy();
  }

  /**
   * 保存密码
   */
  async saveClick() {
    // 验证表单
    UtilsService.validateForm(this.form);
    
    if (!this.form.valid) {
      return;
    }

    // 验证密码强度
    if (!this.validatePasswordStrength()) {
      this.message.error('密码必须包含字母和数字，且长度至少6位');
      return;
    }

    // 验证新旧密码是否相同
    if (this.form.value.oldPassword === this.form.value.newPassword) {
      this.message.error('新密码不能与旧密码相同');
      return;
    }

    this.loading = true;

    const passwordData = {
      oldPassword: this.form.value.oldPassword,
      newPassword: this.form.value.newPassword
    };
    this.userService.changePassword(passwordData).subscribe(
      (result: any) => {
        this.loading = false;
        if (result.Success) {
          this.message.success('密码修改成功');
          this.modal.triggerOk();
        } else {
          this.message.error(result.Message || '密码修改失败');
        }
      },
      (error) => {
        this.loading = false;
        this.message.error('网络错误，请稍后重试');
        console.error('Password change error:', error);
      }
    );
  }

  /**
   * 更新确认密码的验证状态
   */
  updateConfirmValidator(): void {
    Promise.resolve().then(() => {
      this.form.controls.confirmPassword.updateValueAndValidity();
    });
  }
}